export default function Learn() {
  return (
    <div className="space-y-8">
      <h1 className='text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold mb-4'>Learning Center</h1>

      {/* Video Tutorial Section - with max-width constraint */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden max-w-3xl">
        <div className="p-6 pb-0">
          <h2 className="text-xl font-semibold mb-2">Learn How Neoface Works</h2>
          <p className="text-gray-600 mb-4">See our quick demo on how to anonymize your content using neoface.</p>
        </div>
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            src="https://www.youtube.com/embed/48jPON38LO0?rel=0"
            title="How to use Neoface"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          />
        </div>
      </div>

      {/* Articles Section */}
      <div>
        <h2 className="text-xl md:text-2xl text-slate-800 dark:text-slate-100 font-semibold mb-6">Helpful Articles</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="https://neoface.ai/_next/image?url=%2Fimages%2Fhow-to-neoface-banner.webp&w=3840&q=75"
              alt="Learning Item 1"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-2">Mastering face content with Neoface.ai</h2>
              <p className="text-gray-600 mb-4">Learn how to maximize the strengths of our current model and work within the limitations of neoface's first gen model</p>
              <a
                href="https://www.neoface.ai/blog/how-to-use-neofaceai-for-face-anonymization"
                target="_blank"
                className="inline-block bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600 transition duration-300"
              >
                Read More
              </a>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="https://www.neoface.ai/_next/image?url=%2Fimages%2Fhow-to-bg-2.webp&w=2048&q=75"
              alt="Learning Item 1"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-2">Getting Started with NeoFace.ai</h2>
              <p className="text-gray-600 mb-4">Learn the basics of using NeoFace.ai to anonymize faces in your content.</p>
              <a
                href="https://www.neoface.ai/blog/how-to-anonymize-your-face-as-a-faceless-creator"
                target="_blank"
                className="inline-block bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600 transition duration-300"
              >
                Read More
              </a>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="https://www.neoface.ai/_next/image?url=%2Fimages%2Fmake-money-bg.webp&w=2048&q=75"
              alt="Learning Item 2"
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-2">How to Make Money on OnlyFans Without Showing Your Face</h2>
              <p className="text-gray-600 mb-4">
                Learn the industry standard ways to grow your OnlyFans income without revealing your identity
              </p>
              <a
                href="https://www.neoface.ai/blog/how-to-make-money-on-onlyfans-without-showing-face"
                className="inline-block bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600 transition duration-300"
              >
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}